import cx from 'classnames';
import { prams_and_accessories as pramsAndAccessoriesCategory } from 'mk/autogenerated/bzCategories';
import {
    BUY,
    FROM,
    STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR,
    STROLLER_DETAIL_GO_TO_BAZAAR,
    STROLLER_DETAIL_WHERE_TO_BUY,
} from 'mk/autogenerated/translations/StrollerDetailWhereToBuy.8613f8e822ba23b170627aac9a1cdc56'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { GCSE_CX } from 'mk/settings';
import { bazaar_single_page_product_grid_category_url } from 'mk/urls/functions';
import { ProductEntity } from 'mk2/apps/bazaar/schemas';
import { Btn, BtnType } from 'mk2/components/Btn';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { StrollerEntity } from 'mk2/schemas';
import React from 'react';
import styles from './StrollerDetailWhereToBuy.mscss';

const pramsCategory = pramsAndAccessoriesCategory.find((c) => c.name === 'prams');

declare const google;
declare const _googCsa;

interface OwnProps {
    className?: string;
    stroller: StrollerEntity;
    oldProductsCount: number;
    cheapestOldProduct: ProductEntity;
    isMobile: boolean;
}

type Props = OwnProps;

export class StrollerDetailWhereToBuy extends React.Component<Props> {

    private resultsRef: HTMLDivElement;
    private gname: string;

    public componentDidMount() {
        this.gname = `stroller-results-${this.props.stroller.id}`;
        this.mountGoogleCSE();
    }

    public render() {
        const { className, stroller, oldProductsCount, cheapestOldProduct } = this.props;

        return (
            <div className={cx(className, styles.StrollerDetailWhereToBuy)}>
                <h2 className={styles.StrollerDetailWhereToBuy__headline}>{STROLLER_DETAIL_WHERE_TO_BUY}</h2>

                <div
                    id={`afscontainer-stroller-${stroller.id}`}
                    className={styles.StrollerDetailWhereToBuy__searchAds}
                />

                <div
                    className={styles.StrollerDetailWhereToBuy__cseResults}
                    ref={(r) => this.resultsRef = r}
                />

                {cheapestOldProduct && (
                    <div className={styles.StrollerDetailWhereToBuy__oldProduct}>
                        <Link
                            className={styles.StrollerDetailWhereToBuy__oldProductLink}
                            to={bazaar_single_page_product_grid_category_url(pramsCategory.slug, {
                                BRAND_MODEL: stroller.name,
                                quality: 'old',
                                sort: 'price',
                            })}
                        >
                            <div className={styles.StrollerDetailWhereToBuy__oldProductImage}>
                                <ImgCropped
                                    photo={cheapestOldProduct.photos[0].photofile}
                                    photoVersion="s221x221"
                                    width={64}
                                    height={64}
                                    mode={ImgCropMode.Cover}
                                />
                            </div>
                            <div className={styles.StrollerDetailWhereToBuy__oldProductInfo}>
                                <Interpolate
                                    className={styles.StrollerDetailWhereToBuy__oldProductInfoCount}
                                    i18nKey={STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR}
                                    count={oldProductsCount}
                                    parent="div"
                                />
                                <div className={styles.StrollerDetailWhereToBuy__oldProductInfoPrice}>
                                    {oldProductsCount > 1 ? `${FROM.toLowerCase()} ` : null}
                                    {formatPrice(cheapestOldProduct.price)}
                                </div>
                            </div>
                        </Link>
                        <Btn
                            type={BtnType.Blue}
                            label={STROLLER_DETAIL_GO_TO_BAZAAR}
                            link={bazaar_single_page_product_grid_category_url(pramsCategory.slug, {
                                BRAND_MODEL: stroller.name,
                                quality: 'old',
                                sort: 'price',
                            })}
                        />
                    </div>
                )}
            </div>
        );
    }

    private mountGoogleCSE = () => {
        const scripttag = document.querySelector('script#cse');
        if (!scripttag) {
            (window as any).__gcse = {
                parsetags: 'explicit',
                callback: this.renderResults,
            };

            const gcse: HTMLScriptElement = document.createElement('script');
            gcse.id = 'cse';
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = 'https://cse.google.com/cse.js?cx=' + GCSE_CX;
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);

            const gcsa1: HTMLScriptElement = document.createElement('script');
            gcsa1.async = true;
            gcsa1.src = 'https://www.google.com/adsense/search/ads.js';
            s.parentNode.insertBefore(gcsa1, s);

            const gcsa2: HTMLScriptElement = document.createElement('script');
            gcsa2.type = 'text/javascript';
            gcsa2.text = '(function(g,o){g[o]=g[o]||function(){(g[o][\'q\']=g[o][\'q\']||[]).push(\n' +
                '  arguments)},g[o][\'t\']=1*new Date})(window,\'_googCsa\');';
            s.parentNode.insertBefore(gcsa2, s);
        } else {
            this.renderResults();
        }
    };

    private renderResults = () => {
        if (typeof google === 'undefined') {
            return;
        }

        if (document.readyState === 'complete') {
            this.gcseRender();
        } else {
            google.setOnLoadCallback(this.gcseRender);
        }
    };

    private gcseRender = () => {
        google.search.cse.element.render({
            div: this.resultsRef,
            tag: 'searchresults-only',
            gname: this.gname,
        });
        this.executeSearch();
    };

    private executeSearch = () => {
        const { stroller } = this.props;
        const query = `${stroller.name} ${BUY}`;

        if (typeof google !== 'undefined') {
            const element = google.search.cse.element.getElement(this.gname);
            if (element) {
                element.execute(query);
            }
        }

        if (typeof _googCsa !== 'undefined') {
            const containerId = `afscontainer-stroller-${stroller.id}`;
            const pageOptions = {
                pubId: 'partner-pub-8317032171613030',
                styleId: '6461056092',
                query,
            };
            const adblock1 = {
                container: containerId,
            };
            _googCsa('ads', pageOptions, adblock1);
        }
    };
}
